import { Spinner } from "@/components/ui";

/**
 * PageFallback
 *
 * Shown while a lazily-loaded page chunk is being fetched. Deliberately quiet
 * — a single centred spinner, no layout shift.
 */
export function PageFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner size={18} label="Loading page" />
    </div>
  );
}
